jQuery.extend(Date.prototype, {

	monthsLong: ['January','February','March','April','May','June','July','August','September','October','November','December'],
	monthsShort: ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'],
	weekDaysLong: ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],
	weekDayShort: ['Su','Mo','Tu','We','Th','Fr','Sa'],
	weekDayMedium: ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'],

	/**
	 * Return date in mysql format
	 *
	 * @return String
	 */
	getMysqlDate: function () {
		var month = this.getMonth() + 1;
		month = month > 9 ? month : '0' + month;

		var day = this.getDate();
		day = day > 9 ? day : '0' + day;

		var year = this.getFullYear();

		var result = year + '-' + month + '-' + day;

		return result;
	},

	/**
	 * Return time in mysql format
	 *
	 * @return String
	 */
	getMysqlTime: function () {
		var hours = this.getHours();
		hours = hours > 9 ? hours : '0' + hours;

		var mins = this.getMinutes();
		mins = mins > 9 ? mins : '0' + mins;

		var seconds = this.getSeconds();
		seconds = seconds > 9 ? seconds : '0' + seconds;

		return hours + ':' + mins + ':' + seconds;
	},

    /**
     * Return week days array
     * @return days array
     */
    getWeekDaysList: function (type, nonEscape) {
    	var arr = this.weekDaysLong;
		switch (type) {
			case 'medium':
				arr = this.weekDayMedium;
				break;
			case 'short':
				arr = this.weekDayShort;
				break;
		}

        var days = [];
        for (var i = 0; i < arr.length; i++) {
        	if (nonEscape) {
				days.push(Locale.getNonEscape(arr[i]));
			} else {
				days.push(Locale.get(arr[i]));
			}
        }
        if (Config.isMondayFirstDay() === true || parseInt(Config.isMondayFirstDay())) {
            days.push(days.shift());
        }
        return days;
    },

	/**
	 * Returns week day name
	 *
	 * @param type
	 */
	getWeekDayName: function (type) {
		var names = this.getWeekDaysList(type);
		var index = this.getDay();

		if (Config.isMondayFirstDay() === true) {
			index--;
		}
		if (index === -1) {
			index = 6;
		}

		return names[index];
	},

	/**
	 * Returns month name
	 *
	 * @param type
	 * @return {*}
	 */
	getMonthName: function (type) {
		return this.getMonthNameByIndex(this.getMonth(), type);
	},

	/**
	 * Returns month name by month index
	 *
	 * @param index
	 * @param type
	 * @return {*}
	 */
	getMonthNameByIndex: function (index, type) {
		switch (type) {
			case 'short':
				return this.monthsShort[index];
			case 'short_translated':
				return Locale.get(this.monthsShort[index]);
			case 'long_translated':
				var monthName = this.monthsLong[index];
				if (Locale.has('_' + monthName + '_')) {
					return Locale.get('_' + monthName + '_');
				} else {
					return Locale.get(monthName);
				}
			default:
				return this.monthsLong[index];
		}
	},

    /**
     * Return datetime in mysql format
     *
     * @return String
     */
    getMysqlDateTime: function () {
        var date = this.getMysqlDate();
        var time = this.getMysqlTime();

		return date + ' ' + time;
	},

	/**
	 * Return Time object
	 *
	 * @return Object
	 */
	getTimeObj: function () {
		return new Time(this.getMysqlTime());
	},

	/**
	 * Return formatted date
	 *
	 * @return String
	 */
	getFormattedDate: function (nonEscape) {
		return this.formatDate(Config.getDateFormat(), nonEscape);
	},

    getFormattedDateMultiline: function(nonEscape){
        return this.getFormattedDate(nonEscape).replace(',','\n');
    },
    /**
     * Return number days in a specified month
     * @returns {number}
     */

    getMonthDays: function(){
        var d = new Date(this.getFullYear(), this.getMonth() + 1, 0);
        return d.getDate();
    },

	/**
	 * Return formatted time
	 *
	 * @return String
	 */
	getFormattedTime: function () {
		return new Time(this.getMysqlTime()).getFormattedTime();
	},

	/**
	 * Return formatted datetime
	 *
	 * @return String
	 */
	getFormattedDateTime: function (nonEscape) {
		return this.getFormattedDate(nonEscape) + ' ' + this.getFormattedTime();
	},

	/**
	 * Fromat date by format
	 *
	 * @param String format
	 * @return String
	 */
	formatDate: function (format, nonEscape) {
		var translator = Locale.get;
		if (nonEscape) {
			translator = Locale.getNonEscape;
		}

		var result = [];
		for (var i = 0; i < format.length; i++) {
			var str = format[i];
			switch (format[i]) {
				case 'd':
					str = this.getDate() > 9 ? this.getDate() : '0' + this.getDate();
					break;
				case 'j':
					str = this.getDate();
					break;
				case 'm':
					str = this._fixZero(this.getMonth() + 1);
					break;
				case 'Y':
					str = this.getFullYear();
					break;
				case 'y':
					str = new String(this.getFullYear()).substr(2,2);
					break;
				case 'M':
					str = translator(this.monthsShort[this.getMonth()]);
					break;
                case 'F':
                	var monthName = this.getMonthName();
                	if (Locale.has('_' + monthName + '_')) {
						str = translator('_' + monthName + '_');
					} else {
                        str = translator(monthName);
					}
                    break;
				case 'l':
					str = translator(this.weekDaysLong[this.getDay()]);
					break;
                case 'D':
                    str = translator(this.weekDayMedium[this.getDay()]);
                    break;
				case 'H':
					str = this._fixZero(this.getHours());
					break;
				case 'i':
					str = this._fixZero(this.getMinutes());
					break;
				case 's':
					str = this._fixZero(this.getSeconds());
					break;
			}

			result.push(str);
		}
		return result.join('');
	},

	_fixZero: function (val) {
		return val > 9 ? val : '0' + val;
	},
    
    getWeekStart: function () {
        var result = new Date(this);
        var currentWeekDay = this.getDay();
        
        if (Config.isMondayFirstDay() === true || parseInt(Config.isMondayFirstDay())) {
            if (currentWeekDay == 0) currentWeekDay = 7;
            result.setDate(this.getDate() - currentWeekDay + 1);
        } else {
            result.setDate(this.getDate() - currentWeekDay);
        }
        
        return result;
    },
    
    getWeekEnd: function () {
        var result = this.getWeekStart();
        
        result.setDate(result.getDate() + 6);
        
        return result;
    }

});

/**
 * Parse date/datetime string in mysql format
 *
 * @static
 * @param String date
 * @return Date
 */
Date.parseMysqlDate = function (date) {
	var result = new Date();

	var datetimeArr = date.split(' ');
	if (datetimeArr.length) {
		var dateArr = datetimeArr[0].split('-');

		result.setYear(parseInt(dateArr[0], 10));
		result.setMonth((parseInt(dateArr[1], 10) - 1), parseInt(dateArr[2]));
		if (datetimeArr.length > 1) {
			var timeArr = datetimeArr[1].split(':');

			result.setHours(
				parseInt(timeArr[0], 10), parseInt(timeArr[1], 10), 0, 0
			);
		}
	}
	return result;
};

/**
 * Convert php date format to js date format (for ex. datepicker)
 * Php format - http://php.net/manual/ru/function.date.php
 * Bootstrap format - https://bootstrap-datepicker.readthedocs.io/en/latest/options.html
 * Jquery format - http://api.jqueryui.com/datepicker/#utility-formatDate
 * @param phpDateFormat
 * @param bootstrapFormat
 * @returns {string}
 */

Date.convertPhpDateFormatToJs = function(phpDateFormat, bootstrapFormat){
    var result = [];

    for (var i = 0; i < phpDateFormat.length; i++) {
        var str = phpDateFormat[i];
        switch (phpDateFormat[i]) {
            case 'd': //Day of the month, 2 digits with leading zeros	01 to 31
                str = 'dd';
                break;
            case 'm': //Numeric representation of a month, with leading zeros	01 through 12
                str = 'mm';
                break;
            case 'M': //A short textual representation of a month, three letters	Jan through Dec
                str = 'M';
                break;
            case 'y': //A two digit representation of a year	Examples: 99 or 03
				if(bootstrapFormat) {
                    str = 'yy'
                } else {
                    str = 'y';
				}
                break;
            case 'Y': //A full numeric representation of a year, 4 digits	Examples: 1999 or 2003
                if(bootstrapFormat) {
                    str = 'yyyy';
                } else {
                    str = 'yy';
                }
                break;
            case 'l': //A full textual representation of the day of the week	Sunday through Saturday
                str = 'DD';
                break;
        }

        result.push(str);
    }
    return result.join('');
};

Date.today = function () {
	var date = new Date();
	date.setHours(0,0,0,0);
	return date;
}

Date.tomorrow = function () {
	var date = Date.today();
	date.setDate(date.getDate() + 1);
	date.setHours(0,0,0,0);
	return date;
}

Date.yesterday = function () {
	var date = Date.today();
	date.setDate(date.getDate() - 1);
	date.setHours(0,0,0,0);
	return date;
};
define("utils.date", ["jquery","utils.locale"], function(){});

